module.exports = __webpack_public_path__ + "img/bigCenter.c53b7cc9.png";